export default __webpack_public_path__ + "e54a337.png";